module.exports = __webpack_public_path__ + "components/weather-icon/static/nightcloud-b47468ad4881d3189d4232bb2534e3ba.svg";